import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Sidebar.module.scss';
import { SidebarItem } from './SidebarItem';
import { Icon } from '../Icon';
import { UserConfiguration } from 'ais-facade-api/api';

interface SidebarItemI {
  title: string;
  path: string;
  iconName?: string;
  isExternal?: boolean;
  withDivider?: boolean;
  isAvailable?: boolean;
}

type SidebarT = {
  uiConfig?: UserConfiguration | null;
};

export const Sidebar = ({ uiConfig }: SidebarT) => {
  const { t } = useTranslation();

  const [isOpened, setIsOpened] = useState<boolean>(false);

  const SIDEBAR_ITEMS = [
    {
      title: 'Map',
      path: '/',
      iconName: 'map',
    },
    {
      title: 'FleetLabel',
      path: '/fleet',
      iconName: 'catalog-fleet',
    },
    {
      title: 'VesselsPageHeader',
      path: '/vessels',
      iconName: 'catalog-vessels',
    },
    {
      title: 'PortsPageHeader',
      path: '/ports',
      iconName: 'catalog-ports',
    },
    {
      title: 'AtonsPageHeader',
      path: '/atons',
      iconName: 'catalog-atons',
      withDivider: true,
    },
    {
      title: 'History',
      path: '/history',
      iconName: 'catalog-history',
    },
    {
      title: 'Analytics',
      path: '/analytics',
      iconName: 'analytics',
      isAvailable: uiConfig?.analyticsAvailable === true,
    },
    {
      title: 'WorldFleet',
      path: '/world_fleet',
      iconName: 'world-fleet',
      isAvailable: uiConfig?.feGlobalFleetAvailable === true,
    },
    {
      title: 'Areas',
      path: '/areas',
      iconName: 'catalog-areas',
    },
    {
      title: 'EmergencySignals',
      path: '/safety',
      iconName: 'safety-sidebar',
    },
    {
      title: 'Distances',
      path: '/routes',
      iconName: 'routes',
      isAvailable: uiConfig?.feDistanceMeasurementAvailable === true,
    },
    {
      title: 'Notifications',
      path: '/notifications',
      iconName: 'notifications',
      withDivider: true,
    },

    {
      title: 'Playback',
      path: '/playback',
      iconName: 'playback',
      isAvailable: uiConfig?.playbackAvailable === true,
      withDivider: true,
    },
    {
      title: 'Platform',
      path: 'https://platform.sputnix-group.ru',
      isExternal: true,
      iconName: 'platform',
    },
  ];

  const SidebarItems = SIDEBAR_ITEMS.map((item: SidebarItemI) => {
    return (
      <SidebarItem
        key={item.title}
        title={item.title}
        path={item.path}
        isExternal={item.isExternal}
        iconName={item.iconName}
        withDivider={item.withDivider}
        isAvailable={item.isAvailable}
        alt={item.title}
      />
    );
  });
  const handleClick = () => {
    setIsOpened(!isOpened);
  };

  return (
    <aside className={styles.sidebar} data-opened={isOpened}>
      <div className={styles.sidebar_items_wrapper}>{SidebarItems}</div>

      <div className={styles.toggler} onClick={handleClick} title={t('CollapseSidebar')}>
        <div className={styles.item_link}>
          <div className={styles.toggler_icon}>
            <Icon name={isOpened ? 'hide-menu' : 'open-menu'} data-opened={isOpened} />
          </div>
          <div className={styles.toggler_title} data-visible={isOpened}>
            {t('CollapseSidebar')}
          </div>
        </div>
      </div>
    </aside>
  );
};
